import React from 'react';
import { ValidationError } from '../types';
import './ErrorBanner.css';

interface ErrorBannerProps {
  errors: ValidationError[];
  testerNameError?: string;
  onClose: () => void;
  onFieldClick: (field: string) => void;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({
  errors,
  testerNameError,
  onClose,
  onFieldClick,
}) => {
  if (testerNameError) {
    return (
      <div className="error-banner tester-name-error">
        <div className="error-banner-content">
          <span className="error-icon">⚠️</span>
          <span className="error-message">
            Please fill in the Tester Name field before submitting the form.
          </span>
          <button
            className="error-banner-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      </div>
    );
  }

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="error-banner">
      <div className="error-banner-content">
        <span className="error-icon">⚠️</span>
        <span className="error-message">Please complete the following questions</span>
        <button
          className="error-banner-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <div className="error-field-list">
        <div className="error-helper-text">
          Click any question number to go directly to it
        </div>
        <div className="error-question-numbers">
          {errors.map((error, index) => (
            <a
              key={index}
              href="#"
              className="error-field-link"
              onClick={(e) => {
                e.preventDefault();
                onFieldClick(error.field);
              }}
            >
              {error.field.replace(/_/g, ' ')}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ErrorBanner;




